import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TagContract } from '@app-types/api/tag';
import { TagType } from '@app-types/enums/tags';
import { EmailSearchTagInputComponent } from '@app-components/email-search-advanced-dialog/email-search-tag-input/email-search-tag-input.component';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-address-book-filter-drawer',
  imports: [EmailSearchTagInputComponent, MatButtonModule, TranslateModule],
  templateUrl: './address-book-filter-drawer.component.html',
  styleUrls: ['./address-book-filter-drawer.component.scss'],
})
export class AddressBookFilterDrawerComponent implements OnInit {
  @Input({ required: true }) mailAccountId!: number;
  @Input() initialTags: TagContract[] = [];

  @Output() applyFilter = new EventEmitter<TagContract[]>();

  selectedFullTags = new Set<TagContract>();
  readonly tagType = TagType.Contact;

  ngOnInit(): void {
    this.selectedFullTags = new Set(this.initialTags);
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    }
  }

  search(): void {
    this.applyFilter.emit([...this.selectedFullTags]);
  }

  reset(): void {
    this.selectedFullTags = new Set();
    this.applyFilter.emit([]);
  }
}
